module.exports = __webpack_public_path__ + "img/vue1-milieu_lavande.94c68a57.png";